<template>
  <div class="save-point">
    <div class="save-input">
      <span class="trend-title">安全提示数据</span>
      <el-select v-model="value" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    <el-button @click="addSave" style="margin:0.8rem 0" size="small" type="success" icon="el-icon-plus">添加提示</el-button>
    <div v-for="(msg,index) in saveDate" :key="index" class="save-box">
      <div class="save-input">
        <span class="trend-title">提示时间</span>
        <el-date-picker
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="msg.noteTime"
          type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
      </div>
      <div class="save-input">
        <span class="trend-title">事件类型</span>
        <el-select v-model="msg.type" placeholder="请选择">
          <el-option
            v-for="item in thingType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="save-input">
        <span class="trend-title">发生区域</span>
        <el-input type="text" placeholder="请输入" v-model="msg.area"></el-input>
      </div>
      <div class="save-input">
        <span class="trend-title">事件内容</span>
        <el-input type="text" placeholder="请输入" v-model="msg.content"></el-input>
        <el-button @click="delSafe(msg.id,index)" size="small" type="danger" icon="el-icon-minus">删除</el-button>
      </div>
    </div>
    <div class="last-save" style="margin-top:2rem;">
      <el-button :loading="pointLoading" size="small" @click="saveSafe" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/apis/power/power'
export default {
  data(){
    return{
      pointLoading:false,//加载状态

      options: [{
        value: 0,
        label: '从后台获取'
      }, {
        value: 1,
        label: '手工录入'
      }],
      thingType: [
        {
          value: 0,
          label: '安全提示'
        }, 
        {
          value: 1,
          label: '管理提示'
        },
        {
          value: 2,
          label: '能耗突增'
        },
        {
          value: 3,
          label: '能耗超标'
        },
      ],
      value:1,//获取数据方式

      saveDate:[
        {noteTime:'',type:'',area:'',content:''}
      ]
    }
  },
  mounted(){
    this.getSafe()
  },
  methods:{
    //保存数据
    saveSafe(){
      this.pointLoading = true;
      apis.saveSafaty(this.saveDate).then(res=>{
        if(res.code==10000){
          this.$message({
            type: 'success',
            message: '保存成功!'
          });
          this.pointLoading = false;
          this.getSafe()
        }else{
          this.$message.error(res.message);
          this.pointLoading = false;
          return;
        }
      })
    },
    //获取安全数据
    getSafe(){
      apis.getSafaty().then(res=>{
        if(res.code==10000){
          this.saveDate = res.data.list
        }
      })
    },
    //删除安全数据
    delSafe(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apis.delSafaty([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getSafe()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.saveDate.splice(index,1)
      }
    },


    //添加一行安全数据
    addSave(){
      this.saveDate.push({noteTime:'',type:'',area:'',content:''})
    },
  }
}
</script>
<style lang="less" scoped>
.save-point{
  .save-input{ display: inline-block;}
  .save-box{ margin-top: 15px;}
  .trend-title{ width: 7rem;}
  .el-input,.el-select{ display: inline-block; width: 12rem;}
}

</style>